import { render, staticRenderFns } from "./RatingCategories.vue?vue&type=template&id=70011e76&"
import script from "./RatingCategories.vue?vue&type=script&lang=js&"
export * from "./RatingCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports